@if (selectedResult(); as result) {
  <h2 mat-dialog-title class="title">
    <button
      mat-icon-button
      class="back"
      [attr.aria-label]="'AI_ASSISTANT.SHARED.BACK' | translate"
      (click)="backToResults()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="title-text">{{ data.stat.testCase.name }}</span>
    @if (statusMap.get(result.status); as status) {
      <div class="status" [ngClass]="status.class">
        <mat-icon>{{ status.icon }}</mat-icon>
        {{ status.name | translate }}
      </div>
    }
  </h2>

  <mat-dialog-content class="detail-content">
    <ai-evaluator-result-detail [testResult]="result"></ai-evaluator-result-detail>
  </mat-dialog-content>
} @else {
  <h2 mat-dialog-title class="title">
    <span class="title-text">{{ data.stat.testCase.name }}</span>
  </h2>

  <mat-dialog-content class="detail-content">
    <dl class="job-meta">
      @if (data.stat.testCase.scenario) {
        <dt>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.SCENARIO_LABEL' | translate }}</dt>
        <dd>{{ data.stat.testCase.scenario }}</dd>
      }
      @if (data.stat.testCase.expectation) {
        <dt>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.EXPECTATION_LABEL' | translate }}</dt>
        <dd>{{ data.stat.testCase.expectation }}</dd>
      }
    </dl>
    <mat-divider></mat-divider>

    @if (loading()) {
      <!-- Placeholder rows at the real row height, so the table fills in rather
           than appearing after a blank gap. -->
      <div
        class="results"
        aria-busy="true"
        [attr.aria-label]="'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.LOADING' | translate"
      >
        <div class="results-header" aria-hidden="true">
          <span>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CONVERSATION_COLUMN' | translate }}</span>
          <span>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.RESULT_COLUMN' | translate }}</span>
        </div>
        <ul class="result-list" aria-hidden="true">
          @for (placeholder of skeletonRows; track $index) {
            <li>
              <span class="skeleton-row">
                <span class="skeleton skeleton--snippet" [style.width.%]="placeholder"></span>
                <span class="skeleton skeleton--status"></span>
              </span>
            </li>
          }
        </ul>
      </div>
    } @else if (errored()) {
      <glxy-alert type="error">
        {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.RESULTS_LOAD_ERROR' | translate }}
      </glxy-alert>
    } @else if (results().length === 0) {
      <glxy-alert type="info">
        {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.RESULTS_EMPTY' | translate }}
      </glxy-alert>
    } @else {
      <div class="results">
        <div class="results-header" aria-hidden="true">
          <span>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.CONVERSATION_COLUMN' | translate }}</span>
          <span>{{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.RESULT_COLUMN' | translate }}</span>
        </div>

        <ul class="result-list">
          @for (result of results(); track $index) {
            <li>
              <button type="button" class="result-row" (click)="select(result)">
                <span class="conversation">
                  <mat-icon class="modality" inline="true">{{ isVoice(result) ? 'call' : 'chat_bubble' }}</mat-icon>
                  <span class="snippet">{{ snippet(result) }}</span>
                </span>
                @if (statusMap.get(result.status); as status) {
                  <span class="status" [ngClass]="status.class">
                    <mat-icon inline="true">{{ status.icon }}</mat-icon>
                    {{ status.name | translate }}
                  </span>
                }
              </button>
            </li>
          }
        </ul>

        @if (hasMore()) {
          <div class="load-more">
            @if (loadingMore()) {
              <glxy-loading-spinner size="small" inline></glxy-loading-spinner>
            } @else {
              <button mat-stroked-button (click)="loadMore()">
                {{ 'AI_ASSISTANT.SHARED.LOAD_MORE' | translate }}
              </button>
            }
          </div>
        }
      </div>
    }
  </mat-dialog-content>
}

<mat-dialog-actions>
  @if (selectedResult()) {
    <button mat-stroked-button (click)="backToResults()">
      {{ 'AI_ASSISTANT.SHARED.BACK' | translate }}
    </button>
  } @else {
    <button mat-stroked-button (click)="close()">{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
  }
</mat-dialog-actions>
